module.exports = __webpack_public_path__ + "static/img/5.17597fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/sp/5.png
// module id = jyqt
// module chunks = 0